import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  useCallback,
  useMemo,
} from "react";
import { PubSub } from "aws-amplify";
import { useParams, useNavigate } from "react-router-dom";
import classNames from "classnames";
import html2canvas from "html2canvas";
import Icons from "../../utils/components/icons";
import DropDown from "../../utils/components/common/dropdown/dropdown";
import GuageChart from "../../utils/components/common/guageChart";
import DeviceChart from "../../utils/components/common/deviceChart/deviceChart";
import EmptyScreen from "../../utils/components/common/EmptyScreen/EmptyScreen";
import SearchDevice from "../../utils/components/common/searchDevice/SearchDevice";
import ListsView from "./listsView/ListsView";
import WifiListing from "./wifiListing/WifiListing";
import Modal from "../../utils/components/common/modal";
import {
  cartridgeColorFinder,
  formatDate,
  modeChecker,
  round5ForCatridge,
  takeScreenShot,
  valueFinderByModes,
} from "../../utils/utils";
import { backendConfig } from "../../config/BackendConfig";
import { getLocationAndHierarchyDetails } from "../../services/LocationService";
import {
  updateLocationOfDevice,
  createDeviceEntry,
  getDeviceTelemetry,
  performModeChange,
} from "../../services/DeviceService";
import "./deviceView.scss";
import LoadingSpinner from "../../utils/components/common/loadingSpinner/LoadingSpinner";
import {
  UserContext,
  OrganisationContext,
  NotificationContext,
  ReportsDownloadUpdate,
} from "../../layouts/MainLayout";
import { getAllDeviceList } from "../../services/DeviceService";
import { getEventsAndNotifications } from "../../services/EventsNotifications";
import { generateGraphReport } from "../../services/ReportService";
import { useTranslation } from "react-i18next";
import ModalComponent from "../../utils/components/common/modalComponent/ModalComponent";
import { USER_ROLES, updateWebInfo } from "../../utils/constants/userConstants";
import {
  DEVICE_MODES,
  getModeValue,
} from "../../utils/constants/deviceConstants";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import OTAUpdates from "./ota/OTAUpdates";
import ScheduleSetting from "./ScheduleSetting";
import moment from "moment";
import { isServiceToolShow } from "../../utils/constants/serviceToolConstant";

const DeviceView = () => {
  const {
    userData,
    userCognitoData,
    loggedInUserRole,
    featureEnabledStatus,
    appTheme,
    refreshRateDeviceView,
    setRefreshRateDeviceView,
  } = useContext(UserContext);
  const { orgData, siteData } = useContext(OrganisationContext);
  const { isEvtListedFromHeader, isNewMode, setIsNewMode, isNewNotification } =
    useContext(NotificationContext);

  const navigate = useNavigate();
  const { t } = useTranslation("device");
  const [telemetryDate, setTelemetryDate] = useState({});

  const screenShotRef = useRef();
  const { id } = useParams();

  const [isDeviceModeErrorModal, setIsDeviceModeErrorModal] = useState(false);
  const [isDeviceNameErrorModal, setIsDeviceNameErrorModal] = useState(false);
  const [deviceNameErrorMessage, setDeviceNameErrorMessage] = useState("");
  const [deviceNameInlineErrorMessage, setDeviceNameInlineErrorMessage] =
    useState("");
  const [isDeviceOtherInfoOpen, setIsDeviceOtherInfoOpen] = useState(false);
  const [graphListView, setGraphListView] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditName, setIsEditName] = useState(false);
  const [wifiModal, setWifiModal] = useState(false);
  const [isTextCoppy, setIsTextCoppy] = useState(false);
  const [manualRefresh, setManualRefresh] = useState(false);
  const [manageScheduleModal, setManageScheduleModal] = useState(false);
  const [allDevices, setAllDevices] = useState();
  const [currentDeviceId, setCurrentDeviceId] = useState(id);
  const [deviceData, setDeviceData] = useState();
  const [showData, setShowData] = useState(false);
  const [deviceTelemetery, setDeviceTelemetery] = useState([]);
  const [deviceTelemeteryListView, setDeviceTelemeteryListView] = useState([]);
  const [deviceName, setDeviceName] = useState("");
  const [deviceEditName, setDeviceEditName] = useState("");
  const [newNotification, setNewNotification] = useState(false);
  const [locationData, setLocationData] = useState([]);
  const [expandedItem, setExpandedItem] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [isLocationDropdownOpen, setIsLocationDropdownOpen] = useState(false);
  const [isFloorDropdownOpen, setIsFloorDropdownOpen] = useState(false);
  const [isRoomDropdownOpen, setIsRoomDropdownOpen] = useState(false);
  const [deviceCurrentLocation, setDeviceCurrentLocation] = useState("");
  const [updateListView, setUpdateListView] = useState(false);
  const [graphModeChangeData, setGraphModeChangeData] = useState([]);
  const [graphTelemetryData, setGraphTelemetryData] = useState([]);
  const [screenshotLoading, setScreenshotLoading] = useState(false);
  const [displayLocation, setDisplayLocation] = useState("");

  const [assignChecker, setAssignChecker] = useState(false);
  const [currentActiveLocation, setCurrentActiveLocation] = useState([]);
  const [locationDetailsList, setLocationDetailsList] = useState([]);
  const [allSelectedLevels, setAllSelectedLevels] = useState([]);
  const [matchingPKs, setMatchingPKs] = useState([]);
  const [matchingSKs, setMatchingSKs] = useState([]);

  const [clickStatus, setClickStatus] = useState({});
  const [tooltipText, setTooltipText] = useState("");
  const [isOTAModalOpen, setIsOTAModalOpen] = useState(false);
  const changeModeLoadingTimeoutRef = useRef(null);
  
  const dropdownRef = useRef(null);

  const [newScheduleEvent, setNewScheduleEvent] = useState({
    isNewScheduleEvent: false,
    isScheduleEventSuccess: false,
    isScheduleEventAction: "",
    scheduleUUID: "",
  });

  const scheduleSub = useRef(null);

  const [reportJobId, setReportJobId] = useState();
  const [executionId, setExecutionId] = useState();
  const { graphReportStatus, setGraphReportStatus } = useContext(
    ReportsDownloadUpdate
  );
  const [graphData, setGraphData] = useState();

  const showGraph = useMemo(() => {
    let show = true;
    if (deviceData?.mode === "OFFLINE") {
      show = false;
    }
    if (!graphData?.modeEvent?.length || !graphData?.telemetryData?.clo2) {
      show = false;
    }
    if (graphListView) {
      show = false;
    }
    return show;
  }, [
    deviceData?.mode,
    graphData?.modeEvent,
    graphData?.telemetryData?.clo2,
    graphListView,
  ]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsLocationDropdownOpen(false);
        setDeviceCurrentLocation(displayLocation);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [displayLocation]);

  const getDeviceEventsAndNotifications = useCallback((params) => {
    getEventsAndNotifications(params)
      .then((response) => {
        const notificationCount = response?.data?.Items
          ? response?.data?.Items.length
          : 0;
        setNewNotification(!!notificationCount);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    getDeviceLocation(deviceData?.DeviceLocation);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceData?.DeviceLocation]);

  useEffect(() => {
    if (userCognitoData?.username && siteData?.id && deviceData?.DeviceUUID) {
      const params = {
        userId: userCognitoData.username,
        siteId: siteData.id,
        deviceId: deviceData.DeviceUUID,
        eventType: "All",
        duration: 24,
        showListed: false, // false, means not listed yet. [New notification]
        timeStamp: "DESC",
        showEvent: false, // Only Notification count is needed. So pass showEvent as false.
      };
      getDeviceEventsAndNotifications(params);
    }
  }, [
    siteData,
    userCognitoData,
    getDeviceEventsAndNotifications,
    isNewNotification,
    deviceData?.DeviceUUID,
  ]);

  useEffect(() => {
    /**isEvtListedFromHeader: If notification opened from header then reset the isNewNotification
     * to false to remove red alert dot from bell icon
     **/
    setNewNotification(false);
  }, [isEvtListedFromHeader]);

  const getModeList = () => {
    const modeList = [
      { label: "Standby", value: "STANDBY" },
      { label: "Sense Only", value: "SENSE_ONLY" },
      { label: "Operational", value: "OPERATIONAL" },
    ];
    if (featureEnabledStatus.researchMode) {
      modeList.push({ label: "Research", value: "RESEARCH" });
    }
    return modeList;
  };
  const offlineMode = [{ label: "Offline", value: "OFFLINE" }];

  const deviceNameReg = /^[A-Za-z0-9- _:]*$/;

  const changeModeSub = useRef(null);

  const refreshIntervalRef = useRef();
  const deviceLoadingTimeoutRef = useRef();


  const cancelChangeModeLoading = () => {
    setIsDeviceModeErrorModal(true);
    setIsLoading(false);
  };

  const expandLocation = (e, sk, defaultSelected) => {
    e.stopPropagation();

    const updatedExpandedItems = [];

    if (defaultSelected) {
      matchingSKs.forEach((matchingSK) => {
        if (sk.includes(matchingSK)) {
          updatedExpandedItems.push(matchingSK);
        }
      });
      setExpandedItem(updatedExpandedItems);
    } else {
      setExpandedItem(sk);
    }
  };

  // To Show the Entire Heirarchy as Highlighted
  useEffect(() => {
    if (allSelectedLevels) {
      // To Add the Higher Selected Levels in the selectedLocation Array
      const updatedSelectedLocation = [
        ...allSelectedLevels,
        ...selectedLocation,
      ];
      setSelectedLocation(updatedSelectedLocation);
    }
  }, [allSelectedLevels]);

  const handleSelectLocation = (level, address, selectedItemsLevels) => {
    setDeviceCurrentLocation(address);
    setSelectedLocation([]);
    setAllSelectedLevels(selectedItemsLevels); // To Store PKs of the Higher Heirarchy Levels

    //To De-Select Already Select Locations
    if (selectedLocation?.includes(level.PK)) {
      let updatedLocation = deviceCurrentLocation;

      if (level.Type === "Level1") {
        //To delete the entire full string for Level1
        updatedLocation = "";
      } else if (level.Type === "Level2") {
        //To delete all the Characters after the first # for Level2
        updatedLocation = deviceCurrentLocation.substring(
          0,
          deviceCurrentLocation.indexOf("#")
        );
      } else {
        //To delete all the Characters after the last # for Level3
        updatedLocation = deviceCurrentLocation.substring(
          0,
          deviceCurrentLocation.lastIndexOf("#")
        );
      }
      setDeviceCurrentLocation(updatedLocation);
      setSelectedLocation((prevSelected) =>
        prevSelected.filter((selectedPK) => selectedPK !== level.PK)
      );
    } else {
      setSelectedLocation((prevSelected) => [...prevSelected, level.PK]);
    }
    setAssignChecker(false);
  };

  useEffect(() => {
    // To implement the Collapse functionality on De-Selection of the Locations
    if (selectedLocation) {
      setExpandedItem(selectedLocation);
    }
  }, [selectedLocation]);

  useEffect(() => {
    if (displayLocation === t("no_device_selected") || !displayLocation) {
      setSelectedLocation([]);

      setExpandedItem([]);
    }
    setAllSelectedLevels([]);
  }, [displayLocation, isLocationDropdownOpen]);

  // To Handle the Default Active Styling and Expanded Feature of Previously Selected Locations on Page Load
  useEffect(() => {
    const foundPKs = []; // For Storing the Expanded Item's SKs
    const foundSKs = []; // For Storing the Expanded Item's PKs

    if (locationDetailsList) {
      locationDetailsList.forEach((item) => {
        if (currentActiveLocation.includes(item.LocationName)) {
          foundPKs.push(item.PK);
          foundSKs.push(item.SK);
        }

        if (item.Level2) {
          item.Level2.forEach((Level2Item) => {
            if (currentActiveLocation.includes(Level2Item.LocationName)) {
              foundPKs.push(Level2Item.PK);
              foundSKs.push(Level2Item.SK);
            }

            if (Level2Item.Level3) {
              Level2Item.Level3.forEach((level3Item) => {
                if (currentActiveLocation.includes(level3Item.LocationName)) {
                  foundPKs.push(level3Item.PK);
                  foundSKs.push(level3Item.SK);
                }
              });
            }
          });
        }
      });

      setMatchingPKs(foundPKs);
      setMatchingSKs(foundPKs);

      if (displayLocation !== t("no_device_selected") && displayLocation) {
        if (matchingPKs.length) {
          setSelectedLocation(matchingPKs);
        }

        if (matchingSKs.length) {
          const syntheticEvent = { stopPropagation: () => {} }; // To Create a mock event
          expandLocation(syntheticEvent, matchingSKs, true);
        }
      }
    }
  }, [
    locationDetailsList,
    isLocationDropdownOpen,
    displayLocation,
    deviceData,
  ]);

  useEffect(() => {
    if (displayLocation.length) {
      const deviceLocation = deviceData?.DeviceLocation.split("#");

      if (deviceLocation.length !== 2) {
        const activeLocations = deviceLocation.slice(2);
        setCurrentActiveLocation(activeLocations);
      }
    }
  }, [deviceData?.DeviceLocation, displayLocation]);

  useEffect(() => {
    if (deviceCurrentLocation === "" && assignChecker) {
      setDisplayLocation(t("no_device_selected"));
    }
  }, [assignChecker, deviceCurrentLocation, t]);

  const updateDeviceLocation = () => {
    setAssignChecker(true);
    setIsLoading(true);
    const queryParam = {
      Action: "AssignLocation", //userData?.OrganizationID,
      DeviceUUID: deviceData?.DeviceUUID, //userData?.OrganizationID + "#" + siteData.id,
      Location: selectedLocation.length
        ? selectedLocation[selectedLocation.length - 1].toString()
        : siteData.id, // sitedata.id for the "No Location" Selection
      RequestedUserID: userCognitoData.username,
    };
    updateLocationOfDevice(queryParam)
      .then((resp) => {
        setIsLocationDropdownOpen(false);
        setIsLoading(false);
        setDeviceData({
          ...deviceData,
          DeviceLocation:
            orgData.TenantName +
            "#" +
            siteData.label +
            "#" +
            deviceCurrentLocation,
        });
        setSelectedLocation("");
      })
      .catch((error) => {
        setIsLoading(false);
        setIsLocationDropdownOpen(false);
        setDeviceNameErrorMessage(t("change_location_error"));
        setIsDeviceNameErrorModal(true);
        setDeviceCurrentLocation("");
        setSelectedLocation("");
      });
  };

  const getLocationHierarchyDetails = useCallback(() => {
    const queryParams = {
      organizationId: userData?.OrganizationID,
      locationHierarchy: userData?.OrganizationID + "#" + siteData.id,
      requestedByUserId: userCognitoData.username,
      getLocationDeletableStatus: true,
    };
    getLocationAndHierarchyDetails(queryParams)
      .then((resp) => {
        if (resp?.data?.Items?.Level1 && resp.data.Items.Level1.length > 0) {
          setLocationData(resp.data.Items);
        }

        if (resp) {
          setLocationDetailsList(resp?.data?.Items?.Level1);
        }
      })
      .catch((error) => {});
  }, [siteData.id, userCognitoData.username, userData?.OrganizationID]);

  const setChangeModeLoading = () => {
    clearTimeout(changeModeLoadingTimeoutRef?.current);
    setIsLoading(true);
    changeModeLoadingTimeoutRef.current = setTimeout(cancelChangeModeLoading, 15000);
  };

  const cancelDeviceLoading = () => {
    setIsLoading(false);
  };

  const setDeviceLoading = useCallback(() => {
    clearTimeout(deviceLoadingTimeoutRef?.current);
    // setIsLoading(true);
    deviceLoadingTimeoutRef.current = setTimeout(cancelDeviceLoading, 15000);
  }, []);

  const getDeviceList = useCallback(
    (isAutoRefresh = false) => {
      const tenantId = siteData.id;

      if (!tenantId) return;

      clearTimeout(deviceLoadingTimeoutRef?.current);
      !isAutoRefresh && setIsLoading(true);

      const queryParams = {
        tenantId: tenantId,
        getSchedulerStatus: true,
        sort: [{ DeviceName: "asc" }],
        userTimezone: moment.tz.guess(),
      };
      // setShowData(false);
      getAllDeviceList(queryParams)
        .then((response) => {
          setIsLoading(false);
          let data;
          if (currentDeviceId) {
            data = response?.data?.Items.find(
              (device) => currentDeviceId === device?.DeviceUUID
            );
            data = data || response?.data?.Items[0];
          } else {
            data = response?.data?.Items[0];
            setCurrentDeviceId(data?.DeviceUUID);
          }
          /**Add default mode [Offline] for no mode / invalid mode condition */
          data.mode = getModeValue(data?.mode);
          setDeviceData(data);
          setDeviceName(data?.DeviceName);
          setAllDevices(response?.data?.Items); // To keep all device data
          setShowData(true);
          setIsEditName(false);
        })
        .catch((error) => {
          setShowData(true);
          setIsLoading(false);
        });
    },
    [currentDeviceId, deviceLoadingTimeoutRef, siteData.id]
  );

  const handleRefreshBtn = useCallback(() => {
    clearInterval(refreshIntervalRef?.current);
    getDeviceList();
    setUpdateListView((prev) => !prev);
    refreshIntervalRef.current = setInterval(() => {
      getDeviceList(true);
      setUpdateListView((prev) => !prev);
    }, refreshRateDeviceView);
  }, [getDeviceList, refreshRateDeviceView]);

  useEffect(() => {
    if (isNewMode) {
      clearTimeout(changeModeLoadingTimeoutRef?.current);
      getDeviceList(true);
      setIsNewMode(false);
    }
  }, [getDeviceList, isNewMode, setIsNewMode]);

  const updateDeviceName = async (finalDeviceEditName) => {
    setIsLoading(true);
    const queryParam = {
      Action: "Update",
      DeviceUUID: deviceData?.DeviceUUID,
      DeviceName: finalDeviceEditName,
      Location: deviceData?.SK,
      SiteID: "T#" + siteData.id,
      RequestedUserID: userCognitoData.username,
    };
    createDeviceEntry(queryParam)
      .then((resp) => {
        setIsEditName(false);
        setDeviceData({ ...deviceData, DeviceName: finalDeviceEditName });
        const allData = allDevices.map((device) => {
          if (device.DeviceUUID === deviceData?.DeviceUUID) {
            return { ...deviceData, DeviceName: finalDeviceEditName };
          }
          return device;
        });
        setAllDevices(allData);
        setDeviceName(finalDeviceEditName);
        setIsLoading(false);
        setDeviceNameInlineErrorMessage("");
      })
      .catch((error) => {
        setIsEditName(false);
        if (
          error?.response?.data?.Status ===
          "The Device Name must be Unique within a Site. Please try again with a Unique Device Name"
        )
          setDeviceNameErrorMessage(t("change_name_unique_name_error"));
        else {
          setDeviceNameErrorMessage(t("change_name_error"));
        }
        setIsDeviceNameErrorModal(true);
        setIsLoading(false);
        setDeviceNameInlineErrorMessage("");
      });
  };

  const substractHours = (date, hours) => {
    date.setHours(date.getHours() - hours);
    return date;
  };

  const [showLowerDiv, setShowLowerDiv] = useState(false);
  /** Sequence-3: UseEffect to fetch report data on getting MQTT event [graphReportStatus]
   *  and set data in  graphData state using setGraphData
   **/
  useEffect(() => {
    if (
      graphReportStatus &&
      executionId &&
      reportJobId === graphReportStatus?.reportJobId
    ) {
      const getDataFronS3Bucket = async () => {
        try {
          const fetchResponse = await fetch(graphReportStatus?.signedUrl);
          setGraphReportStatus(null);
          const response = await fetchResponse.json();
          setExecutionId();
          setGraphData(response);
        } catch (err) {
          console.log(err);
        }
        setShowLowerDiv(true);
      };
      if (
        graphReportStatus?.reportStatus === "Completed" &&
        graphReportStatus?.signedUrl
      ) {
        getDataFronS3Bucket();
      }

      if (graphReportStatus?.reportStatus === "Failed") {
        console.log(true);
      }
    }
  }, [graphReportStatus, setGraphReportStatus, reportJobId, executionId]);

  const getDeviceGraphData = useCallback(async () => {
    try {
      setShowLowerDiv(false);
      const startDate = substractHours(new Date(), 1);

      const endDate = new Date();
      setGraphTelemetryData([]);
      setGraphModeChangeData([]);
      setTelemetryDate([startDate, endDate]);
      const queryParams = {
        requestedUserId: userCognitoData?.username,
        userId: userCognitoData?.username,
        tenantId: orgData?.TenantId,
        siteId: siteData.id,
        deviceId: deviceData?.DeviceUUID,
        filters: {
          timeStamp: {
            between: [startDate, endDate],
          },
        },
        sort: [
          {
            timeStamp: "asc",
          },
        ],
      };
      const response = await generateGraphReport(queryParams);
      setExecutionId(response?.data?.executionId);
      setReportJobId(response?.data?.jobId);
    } catch (e) {
      setShowLowerDiv(true);
    }
  }, [deviceData?.DeviceUUID, orgData?.TenantId, siteData.id, userCognitoData]);

  const getDeviceTelemetryData = useCallback(async () => {
    const startDate = substractHours(new Date(), 1);
    const endDate = new Date();

    const queryParam = {
      deviceId: deviceData?.DeviceUUID,
      tenantId: userData?.OrganizationID,
      filters: {
        eventDate: {
          between: [startDate, endDate],
        },
      },
      sort: [
        {
          eventDate: "DESC",
        },
      ],
    };
    getDeviceTelemetry(queryParam)
      .then((resp) => {
        if (resp?.data?.Items) {
          setDeviceTelemetery(resp.data.Items);
        }
      })
      .catch((error) => {});
  }, [deviceData?.DeviceUUID, userData?.OrganizationID]);

  const cartridgeColor = (level) => {
    if (deviceData?.mode === "OFFLINE") {
      return "#8C8C8C";
    }
    if (level) {
      if (level < 10) {
        return "#FF2B02";
      } else if (level < 20) {
        return "#FFD012";
      } else {
        return "#07D95A";
      }
    }
    return "#F0F0F0";
  };

  const getDeviceLocation = (dLocation) => {
    if (dLocation) {
      const deviceLocation = dLocation.split("#");

      if (deviceLocation.length === 2) {
        // To Check if there is only one "#" character
        setDisplayLocation(t("no_device_selected"));
      } else {
        const remainingLocation = deviceLocation.slice(2); // To ignore the Tenant and Site Id
        const joinedLocation = remainingLocation.join("/"); // To join the remaining parts
        setDisplayLocation(joinedLocation);
        setDeviceCurrentLocation(remainingLocation.join("#"));
      }
    }
  };

  const changeDeviceMode = useCallback(
    async (mode, deviceDetails) => {
      setIsLoading(true);
      const modeVal = {
        STANDBY: "standBy",
        SENSE_ONLY: "senseOnly",
        OPERATIONAL: "operational",
        RESEARCH: "research",
      };
      const queryParams = {
        siteId: siteData.id,
        deviceId: deviceDetails.DeviceUUID,
        mode: modeVal[mode],
      };
      try {
        const response = await performModeChange(queryParams);
        if (response?.data?.statusCode === "SUCCESS") {
          setChangeModeLoading();
          const url = `chorus/${backendConfig.PUBSUB_ENV}/site/${siteData.id}/notification/events`;
          if (changeModeSub.current) {
            await changeModeSub.current.unsubscribe();
          }
          changeModeSub.current = PubSub.subscribe(url).subscribe({
            next: (data) => {
              clearTimeout(changeModeLoadingTimeoutRef?.current);
              let changedModeVal = data?.value?.mode;
              if (changedModeVal) {
                const modes = {
                  standBy: "STANDBY",
                  senseOnly: "SENSE_ONLY",
                  operational: "OPERATIONAL",
                  research: "RESEARCH",
                };
                deviceDetails.mode = getModeValue(modes[changedModeVal]);
              } else {
                setIsDeviceModeErrorModal(true);
              }
              setIsLoading(false);
            },
            error: (error) => {
              setIsDeviceModeErrorModal(true);
              setIsLoading(false);
            },
            close: () => console.log(""),
          });
        } else {
          setIsDeviceModeErrorModal(true);
          setIsLoading(false);
        }
      } catch (e) {
        setIsLoading(false);
        setIsDeviceModeErrorModal(true);
      }
    },
    [siteData?.id]
  );

  const handleEditName = () => {
    setDeviceEditName(deviceName);
    setIsEditName(true);
  };

  const handleNameChange = (e) => {
    if (e.keyCode === 13 || e.type === "blur") {
      const trimmedDeviceEditName = deviceEditName.trim();

      if (deviceName === trimmedDeviceEditName) {
        setIsEditName(false);
        return;
      }

      if (trimmedDeviceEditName.length < 1) {
        setDeviceNameInlineErrorMessage(t("change_name_empty"));
        return;
      }

      if (!deviceNameReg.test(trimmedDeviceEditName)) {
        setDeviceNameInlineErrorMessage(t("change_name_invalid_name_error"));
        return;
      }
      updateDeviceName(trimmedDeviceEditName);
      setIsEditName(false);
    }
  };

  const handleNameOnchange = (e) => {
    setDeviceEditName(e.target.value);
  };

  const handleClickTakeScreenShot = () => {
    setScreenshotLoading(true);
    const { cropPositionTop, cropPositionLeft, cropWidth, cropHeigth } =
      takeScreenShot(screenShotRef);

    html2canvas(screenShotRef.current, { scale: 1 }).then((canvas) => {
      let croppedCanvas = document.createElement("canvas");
      let croppedCanvasContext = croppedCanvas.getContext("2d");

      croppedCanvas.width = cropWidth;
      croppedCanvas.height = cropHeigth;

      croppedCanvasContext.drawImage(canvas, cropPositionLeft, cropPositionTop);

      const a = document.createElement("a");
      a.href = croppedCanvas.toDataURL();
      a.download = deviceData?.DeviceName + "-telemetry-graph.jpeg";
      a.click();
      setScreenshotLoading(false);
    });
  };

  const copyToClipBoard = (targetedId) => {
    const elem = document.getElementById(targetedId);

    let TempDiv = document.createElement("div");
    TempDiv.innerHTML = elem.innerHTML
      .toString()
      .replaceAll(`mt-1"><span`, `mt-1">; &nbsp; <span`);

    let TempText = document.createElement("input");

    let space = "\u00A0";
    TempText.value = space + TempDiv.textContent;

    document.body.appendChild(TempText);
    TempText.select();

    document.execCommand("copy");
    document.body.removeChild(TempText);

    setClickStatus((prevStatus) => ({
      ...prevStatus,
      [targetedId]: !prevStatus[targetedId],
    }));

    setTooltipText(t("text_copied"));

    setTimeout(() => {
      setTooltipText("");
    }, 1000); // To Clear tooltip after 1 second
  };

  const modeLabelFinder = useCallback(
    (mode) => {
      switch (mode) {
        case "OFFLINE":
          return t("modes.Offline");
        case "SENSE_ONLY":
          return t("modes.SenseOnly");
        case "STANDBY":
          return t("modes.Standby");
        case "OPERATIONAL":
          return t("modes.Operational");
        case "RESEARCH":
          return t("modes.Research");
        default:
          return "";
      }
    },
    [t]
  );

  const downloadCSV = () => {
    const data = deviceTelemetery.map((item) => ({
      PPB: item?.clo2Value ? Math.round(item?.clo2Value) : 0,
      Mode: modeLabelFinder(getModeValue(item?.mode)),
      "Cartridge (%)": item?.cartridgeLevel
        ? Math.round(item?.cartridgeLevel)
        : 0,
      "Temp (Â°C)": item?.temperature ? Math.round(item?.temperature) : 0,
      "Humidity (%)": item?.humidity ? Math.round(item?.humidity) : 0,
      Timestamp: item?.timeStamp,
    }));
    const fileName = deviceData?.DeviceName + "- last 60 min - telemetry CSV";

    // To Convert the data to a CSV string
    let csv = "\uFEFF";
    csv += Object.keys(data[0]).join(",") + "\n";

    data.forEach((item) => {
      const values = Object.values(item).map((value) =>
        typeof value === "string" ? `"${value}"` : value
      );
      csv += values.join(",") + "\n";
    });

    const encodedUri =
      "data:text/csv;charset=utf-16le," + encodeURIComponent(csv);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", fileName + ".csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    setDeviceLoading();
    if (userData?.OrganizationID) {
      handleRefreshBtn();
    }
    return () => {
      clearInterval(refreshIntervalRef?.current);
      clearTimeout(deviceLoadingTimeoutRef?.current);
    };
  }, [
    userData,
    manualRefresh,
    orgData,
    siteData,
    currentDeviceId,
    setDeviceLoading,
    handleRefreshBtn,
  ]);

  useEffect(() => {
    if (deviceData?.DeviceUUID) {
      getDeviceTelemetryData();
      getDeviceGraphData();
    }
  }, [deviceData, getDeviceGraphData, getDeviceTelemetryData]);

  useEffect(() => {
    return () => {
      clearTimeout(changeModeLoadingTimeoutRef?.current);

      if (changeModeSub.current) {
        changeModeSub.current.unsubscribe();
      }
    };
  }, []);

  const openEvtAndNotification = useCallback(() => {
    navigate(`/events-and-notifications/${deviceData?.DeviceUUID}`, {
      state: { deviceName: deviceData?.deviceName },
    });
  }, [deviceData, navigate]);

  const updateDeviceSelection = useCallback(
    (deviceId) => {
      const data = allDevices.find((device) => device.DeviceUUID === deviceId);
      /**Add default mode [Offline] for no mode/ invalid mode condition */
      data.mode = getModeValue(data?.mode);
      setDeviceData(data);
      setDeviceName(data.DeviceName);
      // setCurrentDeviceId(data?.DeviceUUID);
      navigate(`/device-view/${data?.DeviceUUID}`);
    },
    [allDevices, navigate]
  );

  useEffect(() => {
    setCurrentDeviceId(id);
  }, [id]);

  useEffect(() => {
    if (userData?.OrganizationID && siteData?.id && userCognitoData?.username) {
      getLocationHierarchyDetails();
    }
  }, [userCognitoData, siteData, userData, getLocationHierarchyDetails]);

  const scheduleOperationSub = async () => {
    if (scheduleSub.current) {
      await scheduleSub.current.unsubscribe();
    }

    scheduleSub.current = PubSub.subscribe(
      "chorus/" +
        backendConfig.PUBSUB_ENV +
        "/thing/" +
        deviceData?.DeviceUUID +
        "/scheduler/notification/events"
    ).subscribe({
      next: (data) => {
        setNewScheduleEvent((prevScheduleEvent) => ({
          ...prevScheduleEvent,
          isNewScheduleEvent: !prevScheduleEvent.isNewScheduleEvent,
          isScheduleEventSuccess: data.value.success,
          isScheduleEventAction: data.value.operation,
          scheduleUUID: data.value.scheduleUUID,
        }));
      },
      error: (error) => console.error(error),
      close: () => console.log(""),
    });
  };

  useEffect(() => {
    return () => {
      if (scheduleSub.current) {
        scheduleSub.current.unsubscribe();
      }
      if (scheduleSub.current) {
        scheduleSub.current.unsubscribe();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const redirectToReports = useCallback(() => {
    navigate(`/reports/device-diagnostics`, {
      state: { devicePK: deviceData?.PK },
    });
  }, [deviceData, navigate]);

  const redirectToServiceTool = useCallback(() => {
    navigate(`/service-tool`, {
      state: { devicePK: deviceData?.PK },
    });
  }, [deviceData, navigate]);

  const isSchdEnable = useMemo(() => {
    let schdStatus = deviceData ? deviceData?.scheduleStatus || "" : "";
    return (
      schdStatus?.toLowerCase() === "enabled" && featureEnabledStatus?.scheduler
    );
  }, [deviceData, featureEnabledStatus?.scheduler]);

  const handleRefreshSelection = useCallback(
    (val) => {
      setRefreshRateDeviceView((prevRate) => {
        if (prevRate !== val) {
          return val;
        }
        return prevRate;
      });
      localStorage.setItem("refreshRateDeviceView", val);
      updateWebInfo(userCognitoData?.username);
    },
    [refreshRateDeviceView, userCognitoData]
  );

  const getFormattedVersion = (val) => {
    if (!val) return "NA";
    const [version, time] = val.split(/ (.+)/);
    const isValid = (new Date(time)).getTime();
    if(isNaN(isValid)){
      return val
    }
    const formattedTime = formatDate(time, false, true);
    return `${version} ${formattedTime}`;
  };

  return (
    <div className="bodyInner">
      <div className="bodyContainer">
        <div className="controllesWrapper mb-2 fixSubHeader deviceViewHeaderDiv">
          <div className="" id="device_search_dropdown">
            {allDevices && (
              <SearchDevice
                onClose={updateDeviceSelection}
                defaultSelection={deviceData ? true : false}
                selectedId={deviceData?.DeviceUUID}
                autoid="device_search"
                allDevices={allDevices}
              />
            )}
          </div>
          <div className="d-flex align-items-center deviceViewControls">
            <DropDown
              options={[
                { label: "1 min", value: 60 * 1000 },
                { label: "5 min", value: 5 * 60 * 1000 },
                { label: "10 min", value: 10 * 60 * 1000 },
                { label: "15 min", value: 15 * 60 * 1000 },
              ]}
              wrapperClass="primary"
              autoid="refresh"
              value={refreshRateDeviceView}
              onSelection={(val) => {
                handleRefreshSelection(val);
              }}
            />

            <button
              type="button"
              className="verticalBtn"
              id="refresh_button"
              title="Refresh"
              onClick={() => setManualRefresh(!manualRefresh)}
            >
              {Icons.refreshIcon}
            </button>

            {isServiceToolShow() && (
              <button
                type="button"
                title="Service Tool"
                className="verticalBtn reportbtn"
                id="service-tool"
                onClick={() => redirectToServiceTool()}
              >
                <img
                  src={
                    appTheme === "light"
                      ? require("../../assets/images/icons/service-tool-blue.png")
                      : require("../../assets/images/icons/service-tool.png")
                  }
                  className="img-fluid"
                  alt="service-tool"
                />
              </button>
            )}

            {featureEnabledStatus?.ota && (
              <button
                type="button"
                className="verticalBtn device-tray-action"
                id="ota-button"
                title="OTA"
                onClick={() => setIsOTAModalOpen(true)}
              >
                {deviceData?.otaStatus === "InProgress" ? (
                  <>{Icons.otaInProgressIcon}</>
                ) : deviceData?.otaStatus === "UpdateAvailable" ? (
                  <>{Icons.otaAvailableIcon}</>
                ) : (
                  <>{Icons.otaIcon}</>
                )}
              </button>
            )}

            {featureEnabledStatus?.scheduler && (
              <button
                type="button"
                className="verticalBtn"
                id="manageSchedulesButton"
                title="Device Scheduler Settings"
                onClick={() => {
                  getDeviceList();
                  setManageScheduleModal(!manageScheduleModal);
                }}
                disabled={deviceData?.mode === "OFFLINE"}
              >
                {Icons.manageSchedules}
              </button>
            )}

            <button
              type="button"
              title="Wifi Settings"
              className="verticalBtn wifibtn"
              id="wifi_settings"
              onClick={() => setWifiModal(true)}
              disabled={deviceData?.mode === "OFFLINE"}
            >
              {Icons.wifiIcon}
            </button>

            <button
              type="button"
              title="View Device Diagnostic Report"
              className="verticalBtn reportbtn"
              id="report_list"
              onClick={() => redirectToReports()}
            >
              <img
                src={
                  appTheme === "light"
                    ? require("../../assets/images/statistics.png")
                    : require("../../assets/images/icons/dark_statistics.png")
                }
                className="img-fluid"
                alt="parameter-report"
              />
            </button>

            <button
              type="button"
              className={
                newNotification ? "new-notification verticalBtn" : "verticalBtn"
              }
              title="Notifications"
              onClick={openEvtAndNotification}
              id="notifications"
            >
              {newNotification
                ? Icons.newNotificationIcon
                : Icons.notificationIcon}
            </button>
          </div>
        </div>
        {showData && deviceData ? (
          <div className="d-flex flex-wrap" id="device_details_card_container">
            <div
              className={classNames("card me-4 deviceDetail", {
                active: isDeviceOtherInfoOpen,
              })}
              id="device_details_card"
            >
              <div className="d-flex flex-column fluid align-items-center relative">
                <div
                  className="deviceTitle title fluid mb-3 relative d-flex"
                  id="device_details"
                >
                  Device Details
                  {!isDeviceOtherInfoOpen && (
                    <button
                      className="verticalBtn withoutText otherInfoBtn"
                      id="other_info_open"
                      onClick={() => {
                        setIsDeviceOtherInfoOpen(!isDeviceOtherInfoOpen);
                        setClickStatus({});
                      }}
                    >
                      {Icons.infoIcon}
                    </button>
                  )}
                </div>
                {/* <img
                  src={require("../../assets/images/chorus-img.png")}
                  className="img-fluid"
                  alt="signin"
                /> */}
                <div className="device-img-container">
                  <img
                    src={require("../../assets/images/masked-chrous-device-img.png")}
                    className="img-fluid device-image-info"
                    alt="signin"
                  />
                </div>
                {!isEditName && (
                  <div
                    className="deviceTitle d-flex align-items-center mt-3 text-center"
                    id="device_name"
                  >
                    <span className="device-name">
                      {deviceData?.DeviceName || ""}
                    </span>
                    {deviceData?.DeviceName && (
                      <button
                        id="edit_button"
                        className={`verticalBtn withoutText ${
                          loggedInUserRole === USER_ROLES.viewOnlyUserCorp
                            ? "viewOnlyUser"
                            : ""
                        }`}
                        onClick={handleEditName}
                        disabled={
                          loggedInUserRole === USER_ROLES.viewOnlyUserCorp
                        }
                      >
                        {Icons.editDeviceIcon}
                      </button>
                    )}
                  </div>
                )}
                {isEditName && (
                  <div
                    className="deviceTitle d-flex 

                  align-items-center mt-2"
                    style={{ flexDirection: "column" }}
                  >
                    <input
                      id="edit_name"
                      type="text"
                      placeholder="Enter Device Name"
                      value={deviceEditName}
                      name="DeviceName"
                      maxLength="32"
                      onKeyDown={handleNameChange}
                      onChange={handleNameOnchange}
                      onBlur={handleNameChange}
                    />
                    {deviceNameInlineErrorMessage ? (
                      <div style={{ color: "red" }} className="validationError">
                        {deviceNameInlineErrorMessage}
                      </div>
                    ) : null}
                  </div>
                )}
                <div
                  className={`deviceTitle d-flex align-items-center text-center mt-4 ${
                    loggedInUserRole === USER_ROLES.viewOnlyUserCorp
                      ? "viewOnlyUser"
                      : ""
                  }`}
                >
                  <span
                    className={
                      loggedInUserRole !== USER_ROLES.viewOnlyUserCorp
                        ? "text-decoration-underline"
                        : ""
                    }
                    id="deviceLocationName"
                    onClick={() => {
                      if (loggedInUserRole !== USER_ROLES.viewOnlyUserCorp) {
                        setIsLocationDropdownOpen(!isLocationDropdownOpen);
                      }
                    }}
                  >
                    {displayLocation
                      ? displayLocation
                      : t("no_device_selected")}
                  </span>
                  <button
                    className="verticalBtn"
                    id="assignLocationButton"
                    onClick={() => {
                      setIsLocationDropdownOpen(!isLocationDropdownOpen);
                    }}
                    disabled={loggedInUserRole === USER_ROLES.viewOnlyUserCorp}
                  >
                    {isLocationDropdownOpen ? (
                      <>{Icons.chevronPurpleUpArrowIcon}</>
                    ) : (
                      <>{Icons.chevronDownArrowIcon}</>
                    )}
                  </button>
                  {isLocationDropdownOpen && (
                    <div className="locationDropdownWrapper" ref={dropdownRef}>
                      <div className="d-flex align-items-center justify-content-between deviceTitleAssignDiv">
                        <div className="deviceTitle">
                          {Icons.buildingIcon}
                          <span id="assignLocationText">Assign a location</span>
                        </div>
                        <button
                          className="verticalBtn"
                          id="assignBtn"
                          onClick={updateDeviceLocation}
                        >
                          Assign
                        </button>
                      </div>
                      <div className="dropdownBody">
                        {locationData?.Level1
                          ? locationData.Level1.map((level1, index1) => (
                              <div
                                className="locationItemWrapper"
                                key={`location_level1_${level1.PK}`}
                              >
                                <div
                                  className={classNames("locationItem", {
                                    active: selectedLocation?.includes(
                                      level1.PK
                                    ),
                                  })}
                                  onClick={(e) => {
                                    handleSelectLocation(
                                      level1,
                                      level1?.LocationName
                                    );
                                    expandLocation(e, level1.SK, false);
                                    setIsFloorDropdownOpen(
                                      !isFloorDropdownOpen
                                    );
                                  }}
                                >
                                  <div
                                    className="deviceTitle"
                                    id={`locationItem${index1}`}
                                  >
                                    {Icons.buildingIcon}
                                    <span>{level1?.LocationName}</span>
                                  </div>
                                  {level1?.Level2 ? (
                                    <button
                                      type="button"
                                      className="verticalBtn expandCollapseBtnLocation"
                                      id="expandCollapseBtn"
                                    >
                                      {selectedLocation?.includes(
                                        level1?.PK
                                      ) ? (
                                        <>{Icons.chevronPurpleUpArrowIcon}</>
                                      ) : (
                                        <>{Icons.chevronDownArrowIcon}</>
                                      )}
                                    </button>
                                  ) : null}
                                </div>
                                {expandedItem.includes(level1.PK) &&
                                level1?.Level2
                                  ? level1?.Level2.map((level2, index2) => (
                                      <div
                                        className="locationItemWrapper"
                                        key={`location_level2_${level2.PK}`}
                                      >
                                        <div
                                          className={classNames(
                                            "locationItem",
                                            {
                                              active:
                                                selectedLocation?.includes(
                                                  level2.PK
                                                ),
                                            }
                                          )}
                                          onClick={(e) => {
                                            handleSelectLocation(
                                              level2,
                                              level1?.LocationName +
                                                "#" +
                                                level2?.LocationName,
                                              [level1?.PK]
                                            );
                                            expandLocation(e, level2.SK, false);

                                            setIsRoomDropdownOpen(
                                              !isRoomDropdownOpen
                                            );
                                          }}
                                        >
                                          <div
                                            className="deviceTitle"
                                            id="deviceTitle_level2"
                                          >
                                            {Icons.stairIcon}
                                            <span>{level2?.LocationName}</span>
                                          </div>
                                          {level2?.Level3 ? (
                                            <button
                                              type="button"
                                              className="verticalBtn"
                                            >
                                              {selectedLocation?.includes(
                                                level2.PK
                                              ) ? (
                                                <>
                                                  {
                                                    Icons.chevronPurpleUpArrowIcon
                                                  }
                                                </>
                                              ) : (
                                                <>
                                                  {Icons.chevronDownArrowIcon}
                                                </>
                                              )}
                                            </button>
                                          ) : null}
                                        </div>
                                        {expandedItem.includes(level2.PK) &&
                                        level2?.Level3
                                          ? level2?.Level3.map(
                                              (level3, index3) => (
                                                <div className="locationItemWrapper">
                                                  <div
                                                    className={classNames(
                                                      "locationItem",
                                                      {
                                                        active:
                                                          selectedLocation?.includes(
                                                            level3.PK
                                                          ),
                                                      }
                                                    )}
                                                    onClick={() => {
                                                      handleSelectLocation(
                                                        level3,
                                                        level1?.LocationName +
                                                          "#" +
                                                          level2?.LocationName +
                                                          "#" +
                                                          level3?.LocationName,
                                                        [level1?.PK, level2?.PK]
                                                      );
                                                    }}
                                                  >
                                                    <div
                                                      className="deviceTitle"
                                                      id="deviceTitle_level3"
                                                    >
                                                      {Icons.roomIcon}
                                                      <span>
                                                        {level3?.LocationName}
                                                      </span>
                                                    </div>
                                                  </div>
                                                </div>
                                              )
                                            )
                                          : null}
                                      </div>
                                    ))
                                  : null}
                              </div>
                            ))
                          : null}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {isDeviceOtherInfoOpen && (
                <div className="otherInfo" id="other_info_card">
                  <div className="deviceTitle title fluid" id="other_info">
                    Other Information
                  </div>
                  <div className="d-flex flex-column relative">
                    <button
                      className="verticalBtn withoutText closeBtn"
                      id="other_info_close"
                      onClick={() => {
                        setIsDeviceOtherInfoOpen(!isDeviceOtherInfoOpen);
                        setIsTextCoppy(false);
                      }}
                    >
                      {Icons.closeIconWithCircle}
                    </button>
                    <button
                      className="verticalBtn withoutText copyBtn"
                      onClick={() => copyToClipBoard("deviceOtherInfo")}
                      id="copy"
                      title={isTextCoppy && "Copy to Clipboard"}
                    >
                      {clickStatus?.deviceOtherInfo ? (
                        <span className="checkedIcon">{Icons.checkedIcon}</span>
                      ) : (
                        <span>{Icons.copyIcon}</span>
                      )}
                    </button>
                    <div
                      className="d-flex flex-column relative"
                      id="deviceOtherInfo"
                    >
                      <div className="d-flex fluid mt-3 modelInfo infoContainer">
                        <span className="level" id="model_name">
                          Model Name / Number
                        </span>
                        <span className="separator">: </span>
                        <div className="infoValueContainer">
                          <span className="infoValues" id="modelInfo">
                            {deviceData?.DeviceModel || "NA"}
                          </span>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip">{tooltipText}</Tooltip>
                            }
                            show={!!tooltipText}
                          >
                            <button
                              onClick={() => copyToClipBoard("modelInfo")}
                              id="copy"
                              title={isTextCoppy && "Copy to Clipboard"}
                            >
                              <span>{Icons.copyIcon}</span>
                            </button>
                          </OverlayTrigger>
                        </div>
                      </div>
                      <div className="d-flex fluid mt-1 infoContainer">
                        <span className="level" id="udi">
                          UDI
                        </span>
                        <span className="separator">: </span>
                        <div className="infoValueContainer">
                          <span className="infoValues" id="levelInfo">
                            {deviceData?.UDI || "NA"}
                          </span>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip">{tooltipText}</Tooltip>
                            }
                            show={!!tooltipText}
                          >
                            <button
                              onClick={() => copyToClipBoard("levelInfo")}
                              id="copy"
                              title={isTextCoppy && "Copy to Clipboard"}
                            >
                              <span>{Icons.copyIcon}</span>
                            </button>
                          </OverlayTrigger>
                        </div>
                      </div>
                      <div className="d-flex fluid mt-1 infoContainer">
                        <span className="level" id="cartridge_id">
                          Cartridge ID
                        </span>
                        <span className="separator">: </span>
                        <div className="infoValueContainer">
                          <span className="infoValues" id="cartridgeInfo">
                            {deviceData?.CartridgeID || "NA"}
                          </span>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip">{tooltipText}</Tooltip>
                            }
                            show={!!tooltipText}
                          >
                            <button
                              onClick={() => copyToClipBoard("cartridgeInfo")}
                              id="copy"
                              title={isTextCoppy && "Copy to Clipboard"}
                            >
                              <span>{Icons.copyIcon}</span>
                            </button>
                          </OverlayTrigger>
                        </div>
                      </div>
                      <div className="d-flex fluid mt-1 infoContainer">
                        <span className="level" id="sensor_id">
                          Sensor Panel ID
                        </span>
                        <span className="separator">: </span>
                        <div className="infoValueContainer">
                          <span className="infoValues" id="sensorInfo">
                            {deviceData?.SensorPanelID || "NA"}
                          </span>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip">{tooltipText}</Tooltip>
                            }
                            show={!!tooltipText}
                          >
                            <button
                              onClick={() => copyToClipBoard("sensorInfo")}
                              id="copy"
                              title={isTextCoppy && "Copy to Clipboard"}
                            >
                              <span>{Icons.copyIcon}</span>
                            </button>
                          </OverlayTrigger>
                        </div>
                      </div>
                      <div className="d-flex fluid mt-1 infoContainer">
                        <span className="level" id="comms_version">
                          Comms Version
                        </span>
                        <span className="separator">: </span>
                        <div className="infoValueContainer">
                          <span className="infoValues" id="comsVersionInfo">
                            {getFormattedVersion(deviceData?.commsVersion)}
                          </span>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip">{tooltipText}</Tooltip>
                            }
                            show={!!tooltipText}
                          >
                            <button
                              onClick={() => copyToClipBoard("comsVersionInfo")}
                              id="copy"
                              title={isTextCoppy && "Copy to Clipboard"}
                            >
                              <span>{Icons.copyIcon}</span>
                            </button>
                          </OverlayTrigger>
                        </div>
                      </div>
                      <div className="d-flex fluid mt-1 infoContainer">
                        <span className="level" id="controller_version">
                          Controller Version
                        </span>
                        <span className="separator">: </span>
                        <div className="infoValueContainer">
                          <span
                            className="infoValues"
                            id="controllerVersionInfo"
                          >
                            {getFormattedVersion(deviceData?.controllerVersion)}
                          </span>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip">{tooltipText}</Tooltip>
                            }
                            show={!!tooltipText}
                          >
                            <button
                              onClick={() =>
                                copyToClipBoard("controllerVersionInfo")
                              }
                              id="copy"
                              title={isTextCoppy && "Copy to Clipboard"}
                            >
                              <span>{Icons.copyIcon}</span>
                            </button>
                          </OverlayTrigger>
                        </div>
                      </div>
                      <div className="d-flex fluid mt-1 infoContainer">
                        <span className="level" id="thing_name">
                          Thing Name
                        </span>
                        <span className="separator">: </span>
                        <div className="infoValueContainer">
                          <span className="infoValues" id="thingNameInfo">
                            {deviceData?.DeviceUUID}
                          </span>
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id="tooltip">{tooltipText}</Tooltip>
                            }
                            show={!!tooltipText}
                          >
                            <button
                              onClick={() => copyToClipBoard("thingNameInfo")}
                              id="copy"
                              title={isTextCoppy && "Copy to Clipboard"}
                            >
                              <span>{Icons.copyIcon}</span>
                            </button>
                          </OverlayTrigger>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div
              className="card me-3 deviceParameter"
              id="device_paramter_card"
            >
              <div
                className="d-flex fluid justify-content-between align-items-center"
                id="device_paramter_card_details"
              >
                <div className="deviceTitle title" id="device_params">
                  <span>Device Parameters</span>
                  <span className="desc ms-3" id="last_updated">
                    Last Updated{" "}
                    {formatDate(
                      deviceData?.timeStamp
                        ? new Date(deviceData?.timeStamp)
                        : new Date(),
                      false,
                      true
                    )}
                  </span>
                </div>

                <div className="infoIconContainer">
                  {isSchdEnable && (
                    <span
                      className={`deviceEnabledScheduler ${
                        deviceData?.mode === "OFFLINE" ? "offline" : ""
                      }`}
                    >
                      {Icons.deviceSchedulerIsEnabledIcon}
                    </span>
                  )}
                  {/* {deviceData?.schedulerEnabledStatus && (
                    <span>{Icons.deviceSchedulerIsEnabledIcon}</span>
                  )} */}

                  <DropDown
                    options={
                      deviceData?.mode === "OFFLINE"
                        ? offlineMode
                        : getModeList()
                    }
                    value={deviceData?.mode}
                    hideSelectedOption
                    wrapperClass={
                      deviceData?.mode === "OFFLINE" ? "greyLight" : "secondary"
                    }
                    alwaysShowIcon={true}
                    identifier={deviceData}
                    autoid={`changemode`}
                    onSelection={changeDeviceMode}
                    disabled={loggedInUserRole === USER_ROLES.viewOnlyUserCorp}
                  />
                </div>
              </div>
              <div className="cardBody">
                <div className="graph">
                  <GuageChart
                    id={`Device_GuageChart`}
                    targetValue={Math.round(deviceData?.target)}
                    additionalPercentage={30}
                    maxAdditionalPercentage={50}
                    value={
                      modeChecker(deviceData?.mode)
                        ? 0
                        : Math.round(deviceData?.clo2Value)
                    }
                    size="4.0x"
                    showIndicator
                    grayTheme
                    semiCircle={true}
                    mode={deviceData?.mode}
                  />
                  <div className="graphReading deviceView" name="ppb">
                    <span
                      className={
                        deviceData?.mode === "OFFLINE" ? "offlineModePPB" : ""
                      }
                    >
                      {Icons.ppbIcon} PPB
                    </span>
                    <span className="unitValue">
                      {valueFinderByModes(
                        deviceData?.mode,
                        "ppb",
                        deviceData?.clo2Value,
                        false
                      )}
                    </span>
                  </div>
                </div>
                <div
                  className={classNames(
                    "d-flex flex-fill cardBody horizontalBars justify-content-center gaugeData",
                    {
                      offlineMode: deviceData?.mode === "OFFLINE",
                    }
                  )}
                >
                  <div className="d-flex align-items-center justify-content-center mt-4 gaugeDataDetails">
                    <button
                      type="button"
                      id="temerature_button"
                      name="temperature"
                      className="verticalBtn horizontal flex-wrap justify-content-center"
                      title={`Device Temperature: ${valueFinderByModes(
                        deviceData?.mode,
                        "temperature",
                        deviceData?.temperature,
                        true
                      )}`}
                    >
                      {Icons.barometerIcon}
                      <span className="unitValue">
                        {valueFinderByModes(
                          deviceData?.mode,
                          "temperature",
                          deviceData?.temperature,
                          false
                        )}
                        <span className="unit">&deg;C</span>
                      </span>
                      <div className="deviceTitle fluid" id="temperature">
                        Temperature
                      </div>
                    </button>
                    <button
                      type="button"
                      id="humidity_button"
                      name="humidity"
                      className="verticalBtn horizontal flex-wrap justify-content-center"
                      title={`Device Humidity: ${valueFinderByModes(
                        deviceData?.mode,
                        "humidity",
                        deviceData?.humidity,
                        true
                      )}`}
                    >
                      {Icons.dropPercentIcon}
                      <span className="unitValue">
                        {valueFinderByModes(
                          deviceData?.mode,
                          "humidity",
                          deviceData?.humidity,
                          false
                        )}
                        <span className="unit">%</span>
                      </span>
                      <div className="deviceTitle fluid" id="humidity">
                        Humidity
                      </div>
                    </button>
                  </div>

                  <div
                    className="verticalRangeWrapper"
                    id="cartridge_level_element"
                    title={`Device Cartridge Level: 
                    ${valueFinderByModes(
                      deviceData?.mode,
                      "cartridge",
                      deviceData?.cartridgeLevel,
                      true
                    )}
                    `}
                  >
                    <div className="verticalRange" id="cartridge_level">
                      <span
                        className="range"
                        style={{
                          background: cartridgeColor(
                            round5ForCatridge(deviceData?.cartridgeLevel)
                          ),
                          width: `${deviceData?.cartridgeLevel}%`,
                        }}
                      ></span>
                      <span
                        className={`rangeLabel ${cartridgeColorFinder(
                          deviceData?.cartridgeLevel,
                          deviceData?.mode,
                          "deviceView"
                        )}`}
                      >
                        {valueFinderByModes(
                          deviceData?.mode,
                          "cartridge",
                          deviceData?.cartridgeLevel
                        )}
                      </span>
                    </div>
                    {Icons.testTubeIcon}
                  </div>
                  {/* <div
                    className="verticalRangeWrapper mt-4"
                    title={`Device Water Level: ${deviceData?.waterLevel}`}
                  >
                    <div className="verticalRange">
                      <span
                        className="range"
                        style={{
                          background: getWaterLevelColor(
                            deviceData?.waterLevel
                          ),
                          width: getWaterLevelHeight(deviceData?.waterLevel),
                        }}
                      ></span>
                      <span className="rangeLabel">
                        {getWaterLevelValue(deviceData?.waterLevel)}
                      </span>
                    </div>
                    {Icons.waterIcon}
                  </div> */}
                </div>
              </div>
            </div>
            {showLowerDiv ? (
              <div className="fluid d-flex justify-content-end mt-4 actionCard">
                {!graphListView && (
                  <>
                    <div className="camera-container">
                      <button
                        type="button"
                        className="verticalBtn"
                        onClick={handleClickTakeScreenShot}
                        id="screenshot"
                        title="Screenshot"
                        disabled={showGraph ? screenshotLoading : true}
                      >
                        {Icons.cameraIcon}
                      </button>
                      {screenshotLoading ? (
                        <div
                          className="spinner-border spinner-border-sm"
                          role="status"
                        ></div>
                      ) : (
                        <></>
                      )}
                    </div>
                    <button
                      type="button"
                      className="verticalBtn"
                      onClick={() => setGraphListView(!graphListView)}
                      id="list_View"
                      title="List View"
                      disabled={deviceTelemetery.length === 0}
                    >
                      {Icons.listIcon}
                    </button>
                  </>
                )}
                {graphListView && (
                  <>
                    <button
                      type="button"
                      className="verticalBtn"
                      onClick={downloadCSV}
                      title="Download"
                      id="download"
                      disabled={
                        deviceTelemetery.length === 0 ||
                        deviceTelemeteryListView.length === 0
                      }
                    >
                      {Icons.downloadIcon}
                    </button>
                    <button
                      type="button"
                      className="verticalBtn"
                      title="Graph View"
                      id="graphView"
                      onClick={() => setGraphListView(!graphListView)}
                      disabled={deviceTelemetery.length === 0}
                    >
                      {Icons.graphIcon}
                      {/* <div className="deviceTitle fluid">Graph View</div> */}
                    </button>
                  </>
                )}
              </div>
            ) : (
              <></>
            )}
            {showGraph && !graphListView && showLowerDiv ? (
              <div className="card graphWrapper mt-4">
                <DeviceChart
                  ref={screenShotRef}
                  telemetryDate={telemetryDate}
                  graphData={graphData}
                />
              </div>
            ) : (
              <></>
            )}

            {graphListView && deviceTelemetery.length && showLowerDiv ? (
              <div className="card graphWrapper mt-4">
                <ListsView
                  deviceUUID={deviceData?.DeviceUUID}
                  updateListView={updateListView}
                  updateTelemetryData={(data) =>
                    setDeviceTelemeteryListView(data)
                  }
                />
              </div>
            ) : (
              <></>
            )}
            {(!showGraph && !graphListView) ||
            (graphListView && !deviceTelemetery.length) ? (
              <div className="card graphWrapper mt-3">
                <div className="d-flex justify-content-center fluid">
                  <span className="deviceTitle">No Data Received</span>
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}

        {showData && !deviceData ? (
          <div className="noResultWrapper">
            <EmptyScreen
              img={Icons.noDeviceOnboarded}
              title={t("no_device_found")}
              desc={t("no_device_desc")}
              titleName="noDeviceOnboardedDeviceViewPage"
              descName="noDeviceOnboardedDeviceViewPage"
            />
          </div>
        ) : (
          <></>
        )}
        <div className="bodyFooter"></div>
      </div>

      <Modal
        isOpen={wifiModal}
        onCloseModal={() => setWifiModal(false)}
        className="largeModal"
        idName="wifi_modal"
      >
        <WifiListing
          deviceId={deviceData?.DeviceUUID}
          deviceName={deviceData?.DeviceName}
          deviceMode={deviceData?.mode}
          cancel={() => setWifiModal(false)}
        />
      </Modal>

      <ModalComponent
        idName="device_view_modal"
        isOpen={isDeviceModeErrorModal}
        onCloseModal={() => setIsDeviceModeErrorModal(false)}
        descriptionText={t("change_mode_error")}
      ></ModalComponent>

      <ModalComponent
        idName="device_view_error_modal"
        isOpen={isDeviceNameErrorModal}
        onCloseModal={() => setIsDeviceNameErrorModal(false)}
        descriptionText={deviceNameErrorMessage}
      ></ModalComponent>

      {manageScheduleModal && (
        <ScheduleSetting
          isOpen={manageScheduleModal}
          onCloseModal={() => setManageScheduleModal(false)}
          idName="scheduleSettingModal"
          deviceData={deviceData || {}}
          refreshData={getDeviceList}
          isParentLoading={isLoading}
        />
      )}

      {isOTAModalOpen && (
        <OTAUpdates
          closeModal={() => {
            setIsOTAModalOpen(false);
            handleRefreshBtn();
          }}
          deviceData={deviceData}
          systemUpToDate={deviceData?.otaStatus === "UpToDate"}
          otaStatus={deviceData?.otaStatus}
          refreshDevicePage={handleRefreshBtn}
        />
      )}

      {/* Loader  starts*/}
      {isLoading && <LoadingSpinner />}
      {/* Loader  Ends */}
    </div>
  );
};

export default DeviceView;